import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export type ConfirmDialogVariant = 'default' | 'danger';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ConfirmDialogVariant;
}

interface ConfirmDialogRequest {
  options: Required<ConfirmDialogOptions>;
  resolve: (confirmed: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private requestSubject = new Subject<ConfirmDialogRequest | null>();
  readonly request$ = this.requestSubject.asObservable();

  confirm(options: ConfirmDialogOptions): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      const request: ConfirmDialogRequest = {
        options: {
          title: options.title,
          message: options.message,
          confirmLabel: options.confirmLabel ?? 'Confirm',
          cancelLabel: options.cancelLabel ?? 'Cancel',
          variant: options.variant ?? 'default'
        },
        resolve: (confirmed: boolean) => {
          subscriber.next(confirmed);
          subscriber.complete();
        }
      };
      this.requestSubject.next(request);

      return () => {
        this.requestSubject.next(null);
      };
    });
  }
}
